import { createApp, onMounted } from 'vue'
import { initFlowbite } from 'flowbite'
import App from './App.vue'

// add this
import './index.css'

createApp(App).mount('#app')

// initialize components based on data attribute selectors
onMounted(() => {
    initFlowbite();
})